import { render, staticRenderFns } from "./notification-container.vue?vue&type=template&id=685cdc22&scoped=true"
import script from "./notification-container.vue?vue&type=script&lang=ts"
export * from "./notification-container.vue?vue&type=script&lang=ts"
import style0 from "./notification-container.vue?vue&type=style&index=0&id=685cdc22&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685cdc22",
  null
  
)

export default component.exports